import * as types from "./actionTypes";

export const setStaticCanvasImage = (staticCanvasImage) => ({
  type: types.SET_STATIC_CANVAS_IMAGE,
  payload: {staticCanvasImage}
});

